import React, { useState } from 'react'
import { PanelScreen } from './PanelScreen'
import { Sidebar } from './Sidebar'

export const AdminScreen = () => {

  const [selectPanel, setselectPanel] = useState('')

  return (
    <div className=' adminScreen '>
  

        <aside className=' sidebar-container'>
        

          <Sidebar setselectPanel={setselectPanel} />

        </aside>

        <section className=' panel '>

        <PanelScreen selectPanel={selectPanel}/>

        </section>

        
    </div>
  )
}
